import MoleculeStructure from "../../Data/MoleculeStructure";

export default function StructureComponent({
    value,
} : {
    value: string,
}) {
    return (
        <div className="w-full p-3 flex justify-center items-center">
            <MoleculeStructure smiles={value} height={200} width={200}/>
        </div>
    )
}